export default class Accordion {
    constructor() {
        this.triggers = $('.accordion__title[data-accordion]')
    }

    /**
     * Handle clicking on accordion titles
     */
    selectItem(e) {
        let me = $(e.currentTarget)
        let target = $(`#accordion-${me.data('accordion')}`)

        $(".accordion__title").removeClass("is-open");
        $(".accordion__body").removeClass("is-open");

        if (target.length) {
            me.toggleClass('is-open')
            target.toggleClass('is-open')
        }
    }

    /**
     * Initialize class
     */
    init() {
        if (this.triggers.length) {
            this.triggers.on('click', e => this.selectItem(e))
        }
    }
}

